import React from 'react';
import moment from 'moment';
import {Link} from 'react-router';

export const PreferencesUpdateModal = (props) => {

    const { cookies, noThanks, isUpdateModalOpen } = props;
    
    const date = moment();

    if( ( cookies.get( 'expiry' ) === undefined || cookies.get( 'expiry' ) < date.format() ) && parseInt( localStorage.loginAs, 10 ) !== 1 && isUpdateModalOpen ){
        return (
            <div className="popup-default">
                <div className="popup-inner">
                    <div className="popup-content">
                        <h3 className="h3">It's been a while, why not check your preferences</h3>
                        <p className="p-tag">Maintaining the privacy and data security of our users is just as much a priority for us as it is for you. To help us to best do this, please take a moment to review your preferences.</p>
                        <ul className="buttons-left">
                            <li>
                                <Link to={`/account/preferences`} type="button" className="btn btn-primary--ghost">
                                    <span className="label">Update Preferences</span>
                                </Link>
                            </li>
                            <li>
                                <button type="button" className="btn btn-primary" onClick={ () => noThanks() }>
                                    <span className="label">No, thanks</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }

    return null;

};

//             otherLoginContent: <div><h3 className="h3">It's been awhile, why not check your preferences</h3><p className="p-tag">Maintaining the privacy and data security of our users is just as much a priority for us as it is for you. To help us to best do this, please take a moment to review your preferences.</p>
//     };
//



// WEBPACK FOOTER //
// src/client/components/common/elements/PreferencesUpdateModal.js